export default __webpack_public_path__ + "static/media/Velocity-Home_07.fcbc98f9.jpg";